<template>
  <v-dialog v-bind="$attrs" @click:outside="$emit('close-dialog')">
    <v-card>
      <v-card-text class="pt-0">
        <v-card-title class="d-flex justify-space-between px-0 py-2">
          <span v-html="dialogData?.title"></span>
          <v-icon @click="$emit('close-dialog')">mdi-close</v-icon>
        </v-card-title>
        <iframe style="width: 100%; height: 800px" :src="fileUrl" title="Document preview" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import AppDialog from "@/components/Base/AppDialog";

export default {
  components: {
    AppDialog,
  },

  props: {
    dialogData: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    fileUrl() {
      return `https://cdn.filestackcontent.com/preview/${this.dialogData?.file}`;
    },
  },
};
</script>
